import type { CompareData } from './Compare'

export const VERCEL: CompareData = {
  slug: 'vercel',
  competitor: 'Vercel',
  competitorDomain: 'vercel.com',
  tagline: 'Front-end cloud for Next.js, with usage-based pricing and per-function billing.',
  summary:
    'Vercel is a human-operated dashboard optimized for Next.js with usage-based billing. OpenDeploy is agent-operated — your AI coding agent drives the deploy end to end — free during beta, with the database included.',
  rows: [
    { feature: 'Operator',            opendeploy: 'Your AI coding agent',         competitor: 'You, through a dashboard' },
    { feature: 'Base price',          opendeploy: 'Free during beta',             competitor: '$20/mo/user + usage' },
    { feature: 'Database included',   opendeploy: 'PostgreSQL, MySQL, Redis, Mongo', competitor: 'No — bring Supabase / Neon' },
    { feature: 'Framework support',   opendeploy: '30+ frameworks',               competitor: 'Primarily JavaScript / Next.js' },
    { feature: 'Usage overages',      opendeploy: 'None — flat pricing',          competitor: 'Per request, per GB-hour, per GB egress' },
    { feature: 'Deploy command',      opendeploy: '"deploy this" inside your agent', competitor: 'vercel deploy from terminal' },
    { feature: 'Best for',            opendeploy: 'Agent-built full-stack apps',  competitor: 'Pure Next.js / React at scale' },
  ],
  chooseUs: [
    'You want your AI agent to deploy end to end, not switch tabs to a dashboard.',
    'You need a managed database without wiring Supabase or Neon.',
    'You are using a non-JavaScript framework (Python, Go, Rails, Laravel, Rust, Java).',
    'You want flat pricing with no per-request or per-GB overages.',
  ],
  chooseThem: [
    'You run pure Next.js at enterprise scale and rely on Vercel Edge Middleware / ISR.',
    'You are already committed to Vercel\'s team workflow.',
  ],
  fullMarkdownPath: '/vs/vercel.md',
}

export const RAILWAY: CompareData = {
  slug: 'railway',
  competitor: 'Railway',
  competitorDomain: 'railway.com',
  tagline: 'Pay-per-service usage-based hosting with a developer-friendly UX.',
  summary:
    'Railway is a human-operated container host priced per service. OpenDeploy is agent-operated and flat-priced — your AI agent drives every deploy and the database is bundled in.',
  rows: [
    { feature: 'Operator',            opendeploy: 'Your AI coding agent',         competitor: 'You, through a dashboard' },
    { feature: 'Base price',          opendeploy: 'Free during beta',             competitor: '$5/mo + usage' },
    { feature: 'Typical monthly',     opendeploy: 'Flat, predictable',            competitor: '$20–$60 variable' },
    { feature: 'Database included',   opendeploy: 'Unlimited managed DBs',        competitor: 'Per-GB-month billing' },
    { feature: 'Framework support',   opendeploy: '30+ auto-detected',            competitor: 'Broad (Nixpacks / Docker)' },
    { feature: 'Usage overages',      opendeploy: 'None',                         competitor: 'Per GB RAM, egress, DB storage' },
    { feature: 'Best for',            opendeploy: 'Agent-built apps, flat cost',  competitor: 'Multi-service backends with custom tuning' },
  ],
  chooseUs: [
    'You want your AI agent to drive the deploy, not a human in a dashboard.',
    'You want one flat monthly bill instead of six line items.',
    'You run multiple side projects and want unlimited apps + databases in one plan.',
  ],
  chooseThem: [
    'You need fine-grained per-service tuning (CPU/RAM per microservice).',
    'You are already using Railway\'s templates and deploy workflow.',
  ],
  fullMarkdownPath: '/vs/railway.md',
}

export const RENDER: CompareData = {
  slug: 'render',
  competitor: 'Render',
  competitorDomain: 'render.com',
  tagline: 'Managed containers and static sites with per-service pricing.',
  summary:
    'Render is a human-operated container host priced per service with a separate database tier. OpenDeploy is agent-operated, flat-priced, and the database is bundled.',
  rows: [
    { feature: 'Operator',            opendeploy: 'Your AI coding agent',         competitor: 'You, through a dashboard' },
    { feature: 'Base price',          opendeploy: 'Free during beta',             competitor: '$7/mo per service + DB tier' },
    { feature: 'Managed databases',   opendeploy: 'Unlimited, included',          competitor: '$7–$95/mo per PostgreSQL' },
    { feature: 'Background workers',  opendeploy: 'Included',                     competitor: 'Separate billing' },
    { feature: 'Bandwidth',           opendeploy: 'Included up to cap',           competitor: '$30/TB after included' },
    { feature: 'Framework support',   opendeploy: '30+ frameworks',               competitor: 'Broad (Dockerfile / native)' },
    { feature: 'Best for',            opendeploy: 'Agent-built full-stack apps',  competitor: 'Multi-service apps with manual tuning' },
  ],
  chooseUs: [
    'You are running 3+ services and Render\'s per-service costs are adding up.',
    'You want the database included without a per-instance pricing ladder.',
    'You deploy from an AI agent (Cursor, Claude Code, Codex) and want that flow supported natively.',
  ],
  chooseThem: [
    'You need Render\'s specific private networking or autoscaling primitives.',
    'You are already on Render and your infrastructure is tuned around it.',
  ],
  fullMarkdownPath: '/vs/render.md',
}
